import React from 'react';
import css from './SpecificSkillsFormField.module.css';
import { useIntl, FormattedMessage } from 'react-intl';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';

const SpecificSkillsFormField = () => {
  const intl = useIntl();

  return (
    <div className={css.root}>
      {/* Main Question */}
      <label className={css.question}>
        <FormattedMessage id="SpecificSkillsFormField.mainQuestion" />
      </label>

      <FieldArray name="skills">
        {({ fields }) => (
          <div className={css.skillsList}>
            {fields.map((name, index) => (
              <div key={name} className={css.skillRow}>
                <Field name={name}>
                  {({ input, meta }) => (
                    <div className={css.inputContainer}>
                      <input
                        {...input}
                        type="text"
                        placeholder={intl.formatMessage(
                          { id: 'SpecificSkillsFormField.skillPlaceholder' },
                          { number: index + 1 }
                        )}
                        className={`${css.input} ${meta.error && meta.touched ? css.error : ''}`}
                      />
                      {meta.error && meta.touched && (
                        <span className={css.errorText}>{meta.error}</span>
                      )}
                    </div>
                  )}
                </Field>

                <button
                  type="button"
                  onClick={() => fields.remove(index)}
                  disabled={fields.length === 1}
                  className={`${css.removeButton} ${fields.length === 1 ? css.disabled : ''}`}
                  aria-label="Remove skill"
                >
                  <FormattedMessage id="SpecificSkillsFormField.removeButton" />
                </button>
              </div>
            ))}

            {/* Add Button */}
            <button
              type="button"
              onClick={() => fields.push('')}
              className={css.addButton}
              disabled={fields.length >= 10}
            >
              <FormattedMessage id="SpecificSkillsFormField.addAnotherButton" />
            </button>

            {fields.length >= 10 && (
              <p className={css.limitNote}>
                <FormattedMessage id="SpecificSkillsFormField.maxSkillsReached" />
              </p>
            )}
          </div>
        )}
      </FieldArray>
    </div>
  );
};

export default SpecificSkillsFormField;
